export default __webpack_public_path__ + "static/media/SHIPING_RATES.e9f5bf7c.xlsx";